<template>
    <div>
      <img src="../assets/logo.jpg" style="float: left;width: 500px;padding-top: 15%;padding-left: 10%;">
        <form novalidate class="md-layout" id="" @submit.prevent="validateUser" style="position:relative;">
      <md-card class="md-layout-item md-size-50 md-small-size-100" id="regform">
        <md-card-header>
          <div class="md-title">Registration for Basic Course</div>
        </md-card-header>

        <md-card-content>
          <div class="md-layout md-gutter">
            <!-- <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('firstName')">
                <label for="first-name">First Name</label>
                <md-input name="first-name" id="first-name" autocomplete="given-name" v-model="form.firstName" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.firstName.required">The first name is required</span>
                <span class="md-error" v-else-if="!$v.form.firstName.minlength">Invalid first name</span>
              </md-field>
            </div> -->

            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('fullName')">
                <label for="full-name">Full Name</label>
                <md-input name="full-name" id="full-name" autocomplete="family-name" v-model="form.fullName" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.fullName.required">The last name is required</span>
                <span class="md-error" v-else-if="!$v.form.fullName.minlength">Invalid last name</span>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('parentName')">
                <label for="parent-name">Parent Name</label>
                <md-input name="parent-name" id="parent-name" autocomplete="family-name" v-model="form.parentName" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.fullName.required">Parent name is required</span>
                <span class="md-error" v-else-if="!$v.form.fullName.minlength">Invalid last name</span>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('age')">
                <label for="age">Age</label>
                <md-input type="number" id="age" name="age" autocomplete="age" v-model="form.age" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.age.required">The age is required</span>
                <span class="md-error" v-else-if="!$v.form.age.maxlength">Invalid age</span>
              </md-field>
            </div>
          </div>

          <md-field :class="getValidationClass('email')">
            <label for="email">Email</label>
            <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.email" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.email.required">The email is required</span>
            <span class="md-error" v-else-if="!$v.form.email.email">Invalid email</span>
          </md-field>

        <md-field :class="getValidationClass('whatsapp')">
            <label for="whatsapp">Whatsapp/Telegram</label>
            <md-input type="whatsapp" name="whatsapp" id="whatsapp" autocomplete="whatsapp" v-model="form.whatsapp" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.whatsapp.required">The whatsapp is required</span>
          </md-field>

          <md-field>
            <label>Any messages/questions (Optional)</label>
            <md-textarea v-model="form.message"></md-textarea>
            </md-field>

        </md-card-content>

        <md-progress-bar md-mode="indeterminate" v-if="sending" />

        <md-card-actions>
          <md-button type="submit" class="md-primary" :disabled="sending">Continue To Payment</md-button>
        </md-card-actions>
      </md-card>

      <md-snackbar :md-active.sync="userSaved">The user {{ lastUser }} was saved with success!</md-snackbar>
    </form>
    </div>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import {
    required,
    email,
    minLength,
    maxLength
  } from 'vuelidate/lib/validators'

  export default {
    name: 'FormValidation',
    mixins: [validationMixin],
    data: () => ({
      form: {
        fullName: null,
        age: null,
        email: null,
        whatsapp: null,
        parentName: null,
        message: null
      },
      userSaved: false,
      sending: false,
      lastUser: null
    }),
    validations: {
      form: {
        fullName: {
          required
        },
        age: {
          required,
          maxLength: maxLength(3)
        },
        email: {
          required,
          email
        },
        whatsapp: {
            required
        },
        parentName: {
            required
        }
      }
    },
    methods: {
      getValidationClass (fieldName) {
        const field = this.$v.form[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      clearForm () {
        this.$v.$reset()
        this.form.fullName = null
        this.form.age = null
        this.form.email = null
        this.form.parentName = null
        this.form.whatsapp = null
        this.message = null
      },
      saveUser () {
        this.sending = true

        // Instead of this timeout, here you can call your API
        console.log('here')
        localStorage.fullName = this.form.fullName;
        localStorage.age = this.form.age;
        localStorage.email = this.form.email;
        localStorage.parentName = this.form.parentName;
        localStorage.whatsapp = this.form.whatsapp;
        localStorage.message = this.form.message;
        // window.setTimeout(() => {
        //   this.lastUser = `${this.form.fullName}`
        //   this.userSaved = true
        //   this.sending = false
        //   this.clearForm()
        // }, 100)
        this.$router.push("checkout")
      },
      validateUser () {
        this.$v.$touch()
        console.log(this.$v)
        if (!this.$v.$invalid) {
          this.saveUser()
        }
      }
    }
  }
</script>

<style>
#regform {
    display: inline-block;
    margin: auto;
    width: 50%;
    border: 10px solid #ff7a2f;
    padding: 10px;
    top: 5pc;
}
</style>
